module.exports = __webpack_public_path__ + "static/Copernicus-BookItalic-b3ab2db7c59451040474ecf3651b45d3.woff2";